export const initHeartbeat = function(url: string, token: string, sessionId: string) {
    const requestUrl = new URL(`${url}/dniHeartbeat`);
    requestUrl.search = new URLSearchParams({
        token: token,
        session_id: sessionId
    }).toString();
    const requestOptions = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        })
    };

    const beat = () => {
        fetch(requestUrl, requestOptions).catch(() => {
            // Do nothing
        });
    };

    setInterval(beat, 60000);
}    
